/**
 * Created by JIA on 2020/6/29.
 *  Parse and display the text contains our marks
 *      e.g.: This will be \h{highlight} , and a input \i{1|defaultValue}, a full line input \i{f}
 *      \h -> highlight text ,in {} is the content
 *      \i -> input, in {1|defaultValue} the "1" is the default length, the "defaultValue" is the defaultValue of input, if the length is a "f" it will fill rest of current line
 *      \u -> underline text, in {} is the content
 *      \b -> bold text
 *      \p -> text that click can edit, will pop a bottom pop area, {input row count|default value|placeholder} , if {content} it will be the default value
 *      \s -> skip text
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Text, View } from "react-native";
import FAIcon from "react-native-vector-icons/FontAwesome5";

import AutoExpandTextInput from "./AutoExpandTextInput";
import Constants from "../../config/Constants";
import _ from "lodash";
import { convertToPinyin } from "../../utils/Helper";
import { EnumHasFlag, GetDefaultAnswerToShow, ParseMarkText, ParseSentence, ParseSetting } from "../../utils/MarkTextHelper";
import WriteInput from "./WriteInput";
import SimpleSentence from "./SimpleSentence";
//
// /**
//  * Parse the text into Arrays of object
//  *  object will be like
//  *      {
//  *          type: "plaintext"/"highlight"/"input",
//  *          setting:{
//  *              color: "blue", // for highlight
//  *              ...
//  *          },
//  *          text: ""
//  *      }
//  *
//  *      Then we will render it by type
//  * @param str
//  * @constructor
//  */
//
// const ParseMarkTextStrPart = str => {
//     const parseRegExp = /\\([hiu])\{([^}]*)\}/gm;
//
//     if (parseRegExp.test(str)) {
//         parseRegExp.lastIndex = 0; //reset last index since we use g flag
//
//         let matches = parseRegExp.exec(str);
//         if (matches && matches.length === 3) {
//             const type = matches[1];
//
//             switch (type) {
//                 case "h":
//                     return {
//                         type: Constants.TEXT_MARK_TYPE.HIGHLIGHT,
//                         setting: {},
//                         text: matches[2],
//                     };
//                 case "i":
//                     const innerPart = matches[2];
//                     const paramArray = innerPart.split("|");
//                     let initialCharCount = 4;
//                     let defaultValue = "";
//                     if (paramArray.length === 1) {
//                         initialCharCount = paramArray[0];
//                     } else if (paramArray.length === 2) {
//                         initialCharCount = paramArray[0];
//                         defaultValue = paramArray[1];
//                     }
//
//                     return {
//                         type: Constants.TEXT_MARK_TYPE.INPUT,
//                         setting: {
//                             initialCharCount: initialCharCount,
//                             defaultValue: defaultValue,
//                         },
//                         text: "",
//                     };
//                 case "u":
//                     return {
//                         type: Constants.TEXT_MARK_TYPE.UNDERLINE,
//                         setting: {},
//                         text: matches[2],
//                     };
//                 default:
//                     return {
//                         type: Constants.TEXT_MARK_TYPE.PLAIN_TEXT,
//                         setting: {},
//                         text: str,
//                     };
//             }
//         }
//     }
//
//     return {
//         type: Constants.TEXT_MARK_TYPE.PLAIN_TEXT,
//         setting: {},
//         text: str,
//     };
// };
//
// /**
//  * we do not consider nest for now
//  *      use array as a stack to parse strings
//  * @param text
//  * @returns {[]}
//  * @constructor
//  */
// const ParseMarkText = text => {
//     let arr = [];
//     const validTypeChar = ["i", "h", "u"];
//
//     if (text && text.length > 0) {
//         let helperArr = [];
//         let markStarArr = [];
//         let markEndArr = [];
//
//         let isMatching = false;
//         let matchingType = -1; //0 mark start, 1 inner, 2 mark end
//
//         for (let i = 0; i < text.length; i++) {
//             let char = text[i];
//
//             //start match and pop previous as a plain text
//             //if is something like \i{ , we got the start
//             if (char === "\\" && text.length > i + 1 && validTypeChar.indexOf(text[i + 1]) > -1 && text[i + 2] === "{") {
//                 if (!isMatching) {
//                     if (i !== 0) {
//                         arr.push(ParseMarkTextStrPart(helperArr.join("")));
//                     }
//                     helperArr = [];
//                     isMatching = true;
//                     matchingType = 0;
//                 } else {
//                     //nothing to do if already in matching?> this may be nest, we ignore for now
//                 }
//             }
//             helperArr.push(char);
//
//             if (isMatching) {
//                 //met the end part
//                 if (char === "}" && matchingType === 1) {
//                     matchingType = 2;
//                 }
//
//                 switch (matchingType) {
//                     case 0:
//                         markStarArr.push(char);
//                         break;
//                     case 1:
//                         break;
//                     case 2:
//                         markEndArr.push(char);
//                         break;
//                 }
//
//                 //start go to inner part
//                 if (char === "{" && matchingType === 0) {
//                     matchingType = 1;
//                 }
//
//                 //try end match
//                 if (char === "}") {
//                     const startStr = markStarArr.join("");
//                     const endStr = markEndArr.join("");
//                     if (matchingType === 2) {
//                         if (endStr === "}" && /\\([hiu])\{/gm.test(startStr)) {
//                             //end case
//                             isMatching = false;
//                             matchingType = -1;
//                             markStarArr = [];
//                             markEndArr = [];
//                             arr.push(ParseMarkTextStrPart(helperArr.join("")));
//                             helperArr = [];
//                         } else {
//                             //reset to case 1
//                             matchingType = 1;
//                             markEndArr = [];
//                         }
//                     }
//                 }
//             }
//         }
//
//         if (helperArr.length > 0) {
//             arr.push(ParseMarkTextStrPart(helperArr.join("")));
//         }
//     }
//     return arr;
// };
//
const buildValueArray = (parsedArr, showDefaultValue, initInputValueArray) => {
    let inputIndexArray = [];
    let returnArr = [];
    let inputIndex = -1;
    for (let i = 0; i < parsedArr.length; i++) {
        let item = parsedArr[i];

        if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.INPUT) || EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.POP_INPUT) || EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.WRITE_INPUT)) {
            inputIndex += 1;
            let inputDefaultText = "";
            if (showDefaultValue) {
                inputDefaultText = item.setting.defaultValue;
            } else {
                if (initInputValueArray && _.isArray(initInputValueArray) && initInputValueArray.length > inputIndex) {
                    inputDefaultText = initInputValueArray[inputIndex];
                }
            }
            returnArr.push(inputDefaultText);
            inputIndexArray.push(i);
        } else {
            returnArr.push(item.text);
        }
    }

    return {
        valueArray: returnArr,
        inputIndexArray: inputIndexArray,
    };
};

/**
 * if do not has input in this sentence we can use text as container
 * @param array
 * @returns {boolean}
 * @constructor
 */
const HasInputInText = array => {
    // || EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.POP_INPUT) we can support
    return _.filter(array, item => EnumHasFlag(item.type, (Constants.TEXT_MARK_TYPE.INPUT | Constants.TEXT_MARK_TYPE.POP_INPUT))).length > 0;
};

const HasWriteInputInText = array => {
    return _.filter(array, item => EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.WRITE_INPUT)).length > 0;
};

class MarkTextRender extends Component {
    constructor(props) {
        super(props);
        const sentenceCommandObj = ParseSentence(this.props.content);
        const parsedArr = sentenceCommandObj.words; //ParseMarkText(sentenceCommandObj.content);
        const { valueArray, inputIndexArray } = buildValueArray(parsedArr, props.showDefaultInputValue, props.initialInputValue);

        this.state = {
            sentenceMark: sentenceCommandObj.type,
            sentenceSetting: sentenceCommandObj.setting,
            parsedArr: parsedArr,
            valueArr: valueArray,
            inputIndexArray: inputIndexArray,
            hasInput: HasInputInText(parsedArr),
            hasWriteInput: HasWriteInputInText(parsedArr),
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.content !== this.props.content) {
            const sentenceCommandObj = ParseSentence(nextProps.content);
            const parsedArr = sentenceCommandObj.words; //ParseMarkText(sentenceCommandObj.content);
            const { valueArray, inputIndexArray } = buildValueArray(parsedArr, nextProps.showDefaultInputValue, nextProps.initialInputValue);
            if (
                !_.isEqual(this.state.parsedArr, parsedArr) ||
                !_.isEqual(this.state.valueArr, valueArray) ||
                !_.isEqual(this.state.inputIndexArray, inputIndexArray) ||
                !_.isEqual(sentenceCommandObj.type, this.state.sentenceMark) ||
                !_.isEqual(sentenceCommandObj.setting, this.state.sentenceSetting)
            ) {
                this.setState({
                    sentenceMark: sentenceCommandObj.type,
                    sentenceSetting: sentenceCommandObj.setting,
                    parsedArr: parsedArr,
                    valueArr: valueArray,
                    inputIndexArray: inputIndexArray,
                    hasInput: HasInputInText(parsedArr),
                    hasWriteInput: HasWriteInputInText(parsedArr),
                });
            }
        }
    }

    get defFont() {
        if (this.props.defFont) {
            return this.props.defFont;
        }
        return styles.defFont;
    }

    render() {
        if (_.isNumber(this.state.sentenceMark)) {
            if (EnumHasFlag(this.state.sentenceMark, Constants.SENTENCE_MARK_TYPE.DIALOG)) {
                const parsedSetting = ParseSetting(this.state.sentenceSetting);
                if (parsedSetting && parsedSetting.role) {
                    if (_.toLower(parsedSetting.role) === "a") {
                        return this.renderDialog("a");
                    } else if (_.toLower(parsedSetting.role) === "b") {
                        return this.renderDialog("b");
                    }
                }
            }
        }

        return this.renderContent();
    }

    renderContent() {
        const { multiline, containerStyle, extraTextStyle, inputStyle, pinyinMode, showRightOrWrongColor, isReadonly, showTips, placeholderTextColor, showTipsBelow, tipTextStyle } = this.props;

        const sentenceStyle = this.getSentenceStyle(this.state.sentenceMark, this.state.sentenceSetting,
                                                    (this.state.hasInput || this.state.hasWriteInput));
        const children = this.renderWords(pinyinMode, multiline, extraTextStyle, inputStyle, showRightOrWrongColor, isReadonly, showTips, placeholderTextColor, sentenceStyle, showTipsBelow, tipTextStyle);
        //filter the childStyleList
        const pureSentenceStyle = _.pickBy(sentenceStyle, (value, key) => key !== "childStyleList");
        //we split every char as a text and use flex wrap to make sure the input can be inline if it is multilineMode

        return this.state.hasInput || this.state.hasWriteInput ? <View style={[pureSentenceStyle, containerStyle]}>{children}</View> : <SimpleSentence style={[pureSentenceStyle, containerStyle, this.defFont]}>{children}</SimpleSentence>;
    }

    renderWords(pinyinMode, multiline, extraTextStyle, inputStyle, showRightOrWrongColor, isReadonly, showTips, placeholderTextColor, sentenceStyle, showTipsBelow, tipTextStyle) {
        //sentence style may contains childStyleList, because the react-native do not support class like web so we need apply style manually
        let childStyleHelper = this.getChildStyleHelperFromSentenceStyle(sentenceStyle); //item in
        const allChildrenStyleFromSentence = childStyleHelper.all;
        const allCount = this.state.parsedArr.length;

        //try to handle the inside <Text> padding/margin Case
        // we add space at left or right to simulate this
        // also we get the style to fit multilineCase
        //please note that if the root container is <Text> padding/margin will not have any affect
        const filterStyleAndGetSimulateText = (subChildStyle, char) => {
            let finalChar = char;
            let leftCharCount = 0;
            let rightCharCount = 0;
            const styleKeys = ["paddingLeft", "paddingRight", "marginLeft", "marginRight", "paddingHorizontal", "marginHorizontal"];
            const textStyleKeys = [
                "textShadowOffset",
                "color",
                "fontSize",
                "fontStyle",
                "fontWeight",
                "lineHeight",
                "textAlign",
                "textDecorationLine",
                "textShadowColor",
                "fontFamily",
                "textShadowRadius",
                "includeFontPadding",
                "textAlignVertical",
                "fontVariant",
                "letterSpacing",
                "textDecorationColor",
                "textDecorationStyle",
                "textTransform",
                "writingDirection",
            ];
            if (_.has(subChildStyle, "paddingLeft")) {
                leftCharCount += _.ceil(subChildStyle.paddingLeft / this.defFont.fontSize);
            }
            if (_.has(subChildStyle, "paddingRight")) {
                rightCharCount += _.ceil(subChildStyle.paddingRight / this.defFont.fontSize);
            }
            if (_.has(subChildStyle, "marginLeft")) {
                leftCharCount += _.ceil(subChildStyle.marginLeft / this.defFont.fontSize);
            }
            if (_.has(subChildStyle, "marginRight")) {
                rightCharCount += _.ceil(subChildStyle.marginRight / this.defFont.fontSize);
            }
            if (_.has(subChildStyle, "paddingHorizontal")) {
                leftCharCount += _.ceil(subChildStyle.paddingHorizontal / this.defFont.fontSize);
                rightCharCount += _.ceil(subChildStyle.paddingHorizontal / this.defFont.fontSize);
            }
            if (_.has(subChildStyle, "marginHorizontal")) {
                leftCharCount += _.ceil(subChildStyle.marginHorizontal / this.defFont.fontSize);
                rightCharCount += _.ceil(subChildStyle.marginHorizontal / this.defFont.fontSize);
            }

            //we add space to simulate the padding/margin for text
            finalChar = _.repeat("  ", leftCharCount) + char + _.repeat(" ", rightCharCount);

            return {
                finalChar: finalChar,
                styleObj: _.pickBy(subChildStyle, (value, key) => styleKeys.indexOf(key) === -1),
                textOnlyStyle: _.pickBy(subChildStyle, (value, key) => textStyleKeys.indexOf(key) > -1),
            };
        };

        return this.state.parsedArr.map((item, i) => {
            let text = pinyinMode ? convertToPinyin(item.text) : item.text;
            let childStyleFromSentence = _.has(childStyleHelper, _.toString(i)) ? childStyleHelper[_.toString(i)] : {};
            //for the last child case
            if (i === allCount - 1 && _.has(childStyleHelper, "-1")) {
                childStyleFromSentence = { ...childStyleFromSentence, ...childStyleHelper["-1"] };
            }

            if (item.type === Constants.TEXT_MARK_TYPE.INPUT) {
                //for input at the first of content, sentence command left indent use padding left is not useful, convert it to margin left
                let inputContainerStyle = childStyleFromSentence;
                //if input is first item and have padding left childStyleFromSentence, use margin left instead
                if (i === 0 && _.has(childStyleFromSentence, "paddingLeft")) {
                    inputContainerStyle = { marginLeft: childStyleFromSentence.paddingLeft };
                }
                return (
                    <AutoExpandTextInput
                        key={"auto"+i}
                        inputStyle={inputStyle}
                        style={inputContainerStyle}
                        initialCharCount={item.setting.initialCharCount}
                        inputPinyinMode={pinyinMode}
                        trueVal={item.setting.defaultValue}
                        showRightOrWrongColor={showRightOrWrongColor}
                        placeholder={this._getPlaceholderForInput(i)}
                        showTips={showTips}
                        showTipsBelow={showTipsBelow}
                        tipTextStyle={tipTextStyle}
                        defaultValue={this._getDefaultValueForInputToShow(i)}
                        value={this._getValueForInputToShow(i)}
                        onChangeText={val => this._onInputChange(val, i)}
                        onBlur={this._onBlur}
                        placeholderTextColor={placeholderTextColor}
                    />
                );
            }

            let style = [];
            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.BOLD)) {
                style.push(styles.bold);
            }
            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.HIGHLIGHT)) {
                style.push(styles.highlight);
            }
            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.UNDERLINE)) {
                style.push(styles.underline);
            }

            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.POP_INPUT)) {
                /* NOTE: BottomPopInput弹出后，会遮挡住下面的视图，无法滑动
                         暂时替换成AutoExpandTextInput，待优化
                return (
                    <BottomPopInput
                        key={"bottom"+i}
                        style={[style, allChildrenStyleFromSentence, childStyleFromSentence, extraTextStyle]}
                        initialRowCount={item.setting.initialRowCount}
                        inputPinyinMode={pinyinMode}
                        trueVal={item.setting.defaultValue}
                        defaultValue={this._getDefaultValueForInputToShow(i)}
                        value={this._getValueForInputToShow(i)}
                        onChangeText={val => this._onInputChange(val, i)}
                        placeholder={this._getPlaceholderForInput(i)}
                        placeholderTextColor={placeholderTextColor}
                        onBlur={this._onBlur}
                    />
                );
                */
                //for input at the first of content, sentence command left indent use padding left is not useful, convert it to margin left
                let inputContainerStyle = childStyleFromSentence;
                //if input is first item and have padding left childStyleFromSentence, use margin left instead
                if (i === 0 && _.has(childStyleFromSentence, "paddingLeft")) {
                    inputContainerStyle = { marginLeft: childStyleFromSentence.paddingLeft };
                }
                return (
                    <AutoExpandTextInput
                        key={"bottom"+i}
                        inputProps={{multiline: true}}
                        inputStyle={inputStyle}
                        style={inputContainerStyle}
                        initialCharCount={item.setting.initialCharCount}
                        inputPinyinMode={pinyinMode}
                        trueVal={null}
                        showRightOrWrongColor={showRightOrWrongColor}
                        placeholder={this._getPlaceholderForInput(i)}
                        showTips={showTips}
                        showTipsBelow={showTipsBelow}
                        tipTextStyle={tipTextStyle}
                        defaultValue={this._getDefaultValueForInputToShow(i)}
                        value={this._getValueForInputToShow(i)}
                        onChangeText={val => this._onInputChange(val, i)}
                        onBlur={this._onBlur}
                        placeholderTextColor={placeholderTextColor}
                    />
                );
            }

            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.WRITE_INPUT)) {
                return (
                    <WriteInput
                        key={"write"+i}
                        inputStyle={inputStyle}
                        initialCharCount={item.setting.initialCharCount}
                        inputPinyinMode={pinyinMode}
                        trueVal={item.setting.defaultValue}
                        showRightOrWrongColor={showRightOrWrongColor}
                        isReadonly={isReadonly}   //手写填空是否显示铅笔和删除图片的图标
                        placeholder={this._getPlaceholderForInput(i)}
                        defaultValue={this._getDefaultValueForInputToShow(i)}
                        value={this._getValueForInputToShow(i)}
                        onSaveImage={this.props.onSaveImage}
                        onChangeText={val => this._onInputChange(val, i)}
                        onBlur={this._onBlur}
                        placeholderTextColor={placeholderTextColor}
                    />
                );
            }

            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.ICON)) {
                const { name, size, color } = item.setting;
                return <FAIcon name={name} size={size} color={color} style={[style, allChildrenStyleFromSentence, childStyleFromSentence, extraTextStyle]} />;
            }

            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.SKIP)) {
                text = ""; //如果是跳过的，将内容清空，这样就不会显示占位的空位置了
                style.push(styles.skip);
            }

            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.KEYWORD)) {
                style.push(styles.keyword);
            }

            //try to handle the inside <Text> padding/margin Case
            // we add space at left or right to simulate this
            const parsedObj = filterStyleAndGetSimulateText(childStyleFromSentence, text);
            if (!this.state.hasInput) {
                text = parsedObj.finalChar;
                childStyleFromSentence = parsedObj.styleObj;
            }

            return multiline ? (
                _.map(text, (char, ic) => {
                    //for multiline style, we assign the first and last style to the first item and last item(last parent)
                    let subChildStyle = {};
                    if (this.state.hasInput) {
                        //please note that if the root container is <Text> padding/margin will not have any affect
                        //but in the <View> as root case we also will use space to simulate to make sure the layout same as <Text> as root
                        if (i === 0 && ic === 0) {
                            const tp = filterStyleAndGetSimulateText(childStyleFromSentence, char);
                            char = tp.finalChar;
                        }
                        if (i === allCount - 1 && ic === text.length - 1) {
                            const tp = filterStyleAndGetSimulateText(childStyleFromSentence, char);
                            char = tp.finalChar;
                        }
                    }

                    return (
                        <SimpleSentence key={`${i}-${ic}`} style={[this.defFont, style, allChildrenStyleFromSentence, subChildStyle, parsedObj.textOnlyStyle, extraTextStyle]}>
                            {char}
                        </SimpleSentence>
                    );
                })
            ) : (
                <SimpleSentence key={i} style={[this.defFont, style, allChildrenStyleFromSentence, childStyleFromSentence, extraTextStyle]}>
                    {text}
                </SimpleSentence>
            );
        });
    }

    renderDialog = role => {
        return (
            <View
                style={{
                    flexDirection: role === "a" ? "row" : "row-reverse",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginVertical: 10,
                }}>
                <View
                    style={{
                        ...(role === "a" ? { marginRight: 10 } : { marginLeft: 10 }),
                        flex: 1,
                        alignSelf: "flex-start",
                    }}>
                    <View style={styles.avatar}>
                        <Text>{_.toUpper(role)}</Text>
                    </View>
                </View>
                <View style={{ flex: 8 }}>{this.renderContent()}</View>
                <View style={{ flex: 1 }} />
            </View>
        );
    };

    getSentenceStyle = (sentenceCommand, sentenceCommandSetting, hasInput) => {
        let styleObj = hasInput ? styles.container : {};
        let parsedSetting = null;
        if (sentenceCommandSetting) {
            if (_.isString(sentenceCommandSetting) && sentenceCommandSetting !== "") {
                try {
                    parsedSetting = JSON.parse(sentenceCommandSetting);
                } catch (e) {}
            } else if (_.isPlainObject(sentenceCommandSetting)) {
                parsedSetting = sentenceCommandSetting;
            }
        }
        if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.ALIGN_CENTER)) {
            styleObj = { ...styleObj, ...styles.centerAligned };
        } else if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.ALIGN_RIGHT)) {
            styleObj = { ...styleObj, ...styles.rightAligned };
        }

        if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.LEFT_INDENT)) {
            styleObj = { ...styleObj, ...styles.leftIndent };
        }
        if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.DIALOG)) {
            if (parsedSetting && parsedSetting.role) {
                if (_.toLower(parsedSetting.role) === "a") {
                    styleObj = { ...styleObj, ...styles.dialogRoleA };
                } else if (_.toLower(parsedSetting.role) === "b") {
                    styleObj = { ...styleObj, ...styles.dialogRoleB };
                }
            }
        }
        return styleObj;
    };

    /**
     * extract child style by index from sentenceStyle.childStyleList
     * @param sentenceStyle
     * @returns {Object}  // key = itemIndex, value = style list
     */
    getChildStyleHelperFromSentenceStyle = sentenceStyle => {
        const pushForKey = (obj, key, value) => {
            if (_.isPlainObject(value)) {
                if (_.has(childStyleHelper, "0")) {
                    childStyleHelper[key] = { ...childStyleHelper[key], ...value };
                } else {
                    childStyleHelper[key] = value;
                }
            }
        };

        //sentence style may contains childStyleList, because the react-native do not support class like web so we need apply style manually
        let childStyleHelper = {}; //item in
        if (sentenceStyle && sentenceStyle.childStyleList && _.isArray(sentenceStyle.childStyleList) && sentenceStyle.childStyleList.length > 0) {
            _.each(sentenceStyle.childStyleList, (item, i) => {
                if (item.applyTo !== "") {
                    switch (item.applyTo) {
                        case "first":
                            pushForKey(childStyleHelper, "0", item.styleObj);
                            break;
                        case "last":
                            pushForKey(childStyleHelper, "-1", item.styleObj); // -1 stand for the last
                            break;
                        case "index":
                            if (_.isNumber(item.applyToIndex)) {
                                pushForKey(childStyleHelper, _.toString(item.applyToIndex), item.styleObj);
                            }
                            break;
                        case "all":
                            pushForKey(childStyleHelper, "all", item.styleObj);
                            break;
                    }
                }
            });
        }

        return childStyleHelper;
    };

    _onInputChange = (value, index) => {
        let newValArr = _.cloneDeep(this.state.valueArr);
        newValArr[index] = value;

        this.setState({ valueArr: newValArr }, () => {
            if (this.props.onContentChange && _.isFunction(this.props.onContentChange)) {
                this.props.onContentChange(newValArr.join(""));
            }
        });
    };

    _onBlur = () => {
        if (this.props.onBlur && _.isFunction(this.props.onBlur)) {
            this.props.onBlur();
        }
    };

    _getDefaultValueForInputToShow = index => {
        if (this.state.inputIndexArray.indexOf(index) > -1) {
            const rIndex = this.state.inputIndexArray.indexOf(index);
            // if show the default value from mark string, we show it
            if (this.props.initialInputValue && this.props.initialInputValue.length > rIndex) {
                return this.props.initialInputValue[rIndex];
            } else {
                //other wise we show the default value from unit design
                if (this.props.showDefaultInputValue) {
                    const defaultValue = this.state.parsedArr[index].setting.defaultValue;
                    return GetDefaultAnswerToShow(defaultValue);
                }
            }
        }

        return "";
    };

    _getValueForInputToShow = index => {
        if (this.state.inputIndexArray.indexOf(index) > -1) {
            const rIndex = this.state.inputIndexArray.indexOf(index);
            // if show the default value from mark string, we show it
            if (this.props.inputValues && this.props.inputValues.length > rIndex) {
                return this.props.inputValues[rIndex];
            }
        }

        return undefined;
    };

    _getPlaceholderForInput = index => {
        if (this.state.inputIndexArray.indexOf(index) > -1) {
            const rIndex = this.state.inputIndexArray.indexOf(index);
            // if show the default value from mark string, we show it
            if (this.props.inputPlaceHolder && _.isArray(this.props.inputPlaceHolder) && this.props.inputPlaceHolder.length > rIndex) {
                return this.props.inputPlaceHolder[rIndex];
            } else {
                return this.state.parsedArr[index].setting.placeholder;
            }
        }

        return "";
    };

    /**
     * For Outer Use
     * return the value now display on screen as a string
     * @returns {string}
     */
    getWholeValue = () => {
        return this.state.valueArr.join("");
    };

    /**
     * For Outer Use
     * return the value of input now bye sequence
     * @returns {[]}
     */
    getInputValueArray = () => {
        let returnArr = [];
        _.each(this.state.inputIndexArray, item => {
            if (this.state.valueArr.length > item) {
                returnArr.push(this.state.valueArr[item]);
            }
        });

        return returnArr;
    };

    /**
     * For Outer Use
     * return the value parsed from mark string
     * @returns {[]}
     */
    getInputDefaultValueArray = () => {
        let returnArr = [];
        _.each(this.state.inputIndexArray, item => {
            if (this.state.parsedArr.length > item) {
                returnArr.push(this.state.parsedArr[item].setting.defaultValue);
            }
        });

        return returnArr;
    };
}
const styles = {
    defFont: {
        fontSize: 17,
        color: "#242424",
        letterSpacing: 0.1,
        lineHeight: 32,
    },
    bold: {
        fontWeight: "bold",
    },
    highlight: {
        color: "#1785af",
    },
    underline: {
        textDecorationLine: "underline",
    },
    container: {
        flexDirection: "row",
        flexWrap: "wrap",
        alignSelf: "flex-start", // start from left to right
    },
    textContainer: { flexDirection: "row", flexWrap: "wrap" },
    centerAligned: {
        textAlign: "center",
        alignSelf: "center",
        justifyContent: "center",
    },
    rightAligned: {
        textAlign: "right",
        alignSelf: "flex-end",
        justifyContent: "flex-end",
    },
    leftIndent: {
        // paddingLeft: 12,
        childStyleList: [
            {
                applyTo: "first", //['first', 'last' ,'all', 'index'] , apply on the single special child or all
                applyToIndex: 0,
                styleObj: { paddingLeft: 38 },
            },
        ],
    },
    avatar: {
        color: "#333",
        width: 36,
        height: 36,
        borderRadius: 36,
        backgroundColor: "#f2f2f2",
        alignItems: "center",
        justifyContent: "center",
    },
    dialogRole: {
        padding: 10,
        borderRadius: 5,
        maxWidth: 240,
        flexWrap: "wrap",
        overflow: "hidden",
    },
    dialogRoleA: {
        backgroundColor: "#f2f2f2",
        alignSelf: "flex-start",
    },
    dialogRoleB: {
        backgroundColor: "#ffdfd5",
        alignSelf: "flex-end",
    },
    skip: {
        color: "transparent",
        width: 0,
        display: "none",
    },
    keyword: {
        color: "#1785af",
        textDecorationLine: "underline",
    },
};

MarkTextRender.propTypes = {
    containerStyle: PropTypes.object,
    // textContainerStyle: PropTypes.object,
    extraTextStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    content: PropTypes.string,
    onContentChange: PropTypes.func,
    onBlur: PropTypes.func,
    onSaveImage: PropTypes.func,
    multiline: PropTypes.bool,
    pinyinMode: PropTypes.bool,
    showDefaultInputValue: PropTypes.bool, // show the default value parsed from the mark string or not, if it is false, we will try to show value from initialInputValue for the review your input case
    showRightOrWrongColor: PropTypes.bool, //是否显示对错提示
    isReadonly: PropTypes.bool,    //手写是否显示铅笔、删除的图标(查看历史的时候)
    showTips: PropTypes.bool, //是否显示答案提示
    showTipsBelow: PropTypes.bool, //是否在填空下方显示答案提示
    tipTextStyle: PropTypes.object,
    initialInputValue: PropTypes.array,
    inputPlaceHolder: PropTypes.array,
    placeholderTextColor: PropTypes.string,
    inputValues: PropTypes.array, //set input value by code
};
MarkTextRender.defaultProps = {
    containerStyle: {},
    // textContainerStyle: {},
    extraTextStyle: {},
    inputStyle: {},
    content: "",
    onContentChange: () => {},
    onBlur: () => {},
    onSaveImage: null,
    multiline: false,
    pinyinMode: false,
    showDefaultInputValue: false,
    showRightOrWrongColor: false,
    isReadonly: false,
    showTips: false,
    showTipsBelow: false,
    tipTextStyle: {},
    initialInputValue: [],
    inputPlaceHolder: [],
    placeholderTextColor: "#a5a5a5",
    inputValues: [],
};
/**
 * for build init value
 * @param val
 * @param showDefaultValue
 * @param initialInputValue
 */
const GetInitialValueOfData = (val, showDefaultValue, initialInputValue) => {
    const parsedArr = ParseMarkText(val);

    const { valueArray } = buildValueArray(parsedArr, showDefaultValue, initialInputValue);
    return valueArray.join("");
};
export default MarkTextRender;
export { GetInitialValueOfData };
